module.exports = __webpack_public_path__ + "static/media/4.9de7f1ac.png";